import type { BiomeDef, BiomeId, DangerTier } from "./schemas";

export const BIOMES: Record<BiomeId, BiomeDef> = {
  ash_band: {
    id: "ash_band",
    name: "Ash Band",
    groundColor: 0x3a342c,
    accentColor: 0x8a6a3a,
    fogColor: 0x1a1612,
    roughness: 0.55,
    scrapDensity: 1,
    dangerTier: 1,
    threatMult: 0.85,
    spawnCooldownMult: 1.15,
    eliteChance: 0.04,
    heavyBias: 0.7,
  },
  rust_flats: {
    id: "rust_flats",
    name: "Rust Flats",
    groundColor: 0x4a3028,
    accentColor: 0xb05a3a,
    fogColor: 0x1c120e,
    roughness: 0.35,
    scrapDensity: 1.2,
    dangerTier: 2,
    threatMult: 1.1,
    spawnCooldownMult: 0.95,
    eliteChance: 0.1,
    heavyBias: 1,
  },
  scrap_canyon: {
    id: "scrap_canyon",
    name: "Scrap Canyon",
    groundColor: 0x2c3338,
    accentColor: 0x6a7a82,
    fogColor: 0x101418,
    roughness: 0.85,
    scrapDensity: 1.4,
    dangerTier: 3,
    threatMult: 1.45,
    spawnCooldownMult: 0.75,
    eliteChance: 0.18,
    heavyBias: 1.55,
  },
};

export const BIOME_ORDER: BiomeId[] = ["ash_band", "rust_flats", "scrap_canyon"];

export const DANGER_LABELS: Record<DangerTier, string> = {
  1: "Safe",
  2: "Contested",
  3: "Hot",
};

export function dangerLabel(tier: DangerTier): string {
  return DANGER_LABELS[tier];
}
